export const METRIC_LEVELS = [
    "company",
    "department",
    "employee",
    "client",
];
const ALL = METRIC_LEVELS;
const NO_PERSON = ["company", "department", "client"];
export const METRICS = [
    /**
     * **والمستحقُّ في الفترة مقياسُ المقام** — فنسبةُ الالتزام تُقسَم عليه.
     *
     * ويُقاس بـ«موعد التسليم» الداخليّ لا بموعد النشر: **فالموعدُ الذي يُحاسَب
     * عليه من يشتغل هو موعدُ تسليمه**. وهو عمودٌ إلزاميٌّ عند الإنشاء (المرحلة
     * الخامسة) — وفي v2 كان يُقبَل فارغاً **ثم يُستثنى الصفُّ من كل مقياسٍ بصمت**.
     */
    {
        key: "plan_items_due",
        labelKey: "analytics.metric.planItemsDue",
        unit: "count",
        levels: ALL,
        rows: "plan_item",
        direction: "higher-better",
    },
    {
        key: "plan_items_completed",
        labelKey: "analytics.metric.planItemsCompleted",
        unit: "count",
        levels: ALL,
        rows: "plan_item",
        direction: "higher-better",
    },
    /**
     * **والتأخُّرُ لا يُخصَم من النسبة** (قرارُ شادي المسجَّل).
     *
     * فمن أنهى متأخراً **أنهى**. وعقوبتُه الترتيبُ والتذكيرُ اليوميّ، لا رقمٌ
     * يقول إنه لم يُنهِ. وخصمُه كان سيجعل النسبةَ تقيس شيئين فلا تقيس أيّاً منهما.
     */
    {
        key: "completion_rate",
        labelKey: "analytics.metric.completionRate",
        unit: "percent",
        levels: ALL,
        rows: "plan_item",
        direction: "higher-better",
    },
    /**
     * **والمتأخّرُ محدودٌ بالفترة** (قرارُ شادي المسجَّل).
     *
     * فكان في v2 لقطةً «إلى هذه اللحظة» تُؤخَذ من آخر يومٍ في المدى ولا تُجمَع،
     * **ففتحُ تقرير الشهر الماضي يُظهر عددَ المتأخّر اليوم**. وهنا: ما كان موعدُه
     * في الفترة ولم يُنجَز في موعده.
     */
    {
        key: "plan_items_overdue",
        labelKey: "analytics.metric.planItemsOverdue",
        unit: "count",
        levels: ALL,
        rows: "plan_item",
        direction: "lower-better",
    },
    {
        key: "plan_items_open",
        labelKey: "analytics.metric.planItemsOpen",
        unit: "count",
        levels: ALL,
        rows: "plan_item",
        direction: "lower-better",
    },
    /**
     * **والنشرُ في موعده ليس له معنًى لشخص** — النشرةُ تخصّ عنصراً لا إنساناً.
     *
     * ومن يسِم النشرَ موظّفُ وساطةٍ لا صاحبُ العنصر، **فعدُّها عليه يحاسبه على
     * شغلِ غيره**.
     */
    {
        key: "published_on_time",
        labelKey: "analytics.metric.publishedOnTime",
        unit: "count",
        levels: NO_PERSON,
        rows: "publication",
        direction: "higher-better",
    },
    {
        key: "published_late",
        labelKey: "analytics.metric.publishedLate",
        unit: "count",
        levels: NO_PERSON,
        rows: "publication",
        direction: "lower-better",
    },
    /**
     * **وزمنُ الاستجابة يُقاس من الإشارة إلى أوّل ردّ** (قرارُ شادي المسجَّل).
     *
     * **وغيرُ المجابة تُراكِم وتجرّ المتوسطَ لأسفل حتى تُجاب** — فلا يختفي
     * التأخيرُ بتجاهله. وفي v2 كان رقماً واحداً للشركة بلا ترشيحٍ أصلاً، ويُقاس
     * على تعليقات الكروت وحدها.
     */
    {
        key: "avg_response_minutes",
        labelKey: "analytics.metric.avgResponseMinutes",
        unit: "minutes",
        levels: ALL,
        rows: "mention",
        direction: "lower-better",
    },
];
export const METRIC_KEYS = METRICS.map((metric) => metric.key);
const BY_KEY = new Map(METRICS.map((metric) => [metric.key, metric]));
/** **ويُقرأ بمفتاحه أو يُرفَض** — فمقياسٌ مجهولٌ لا يُجاب برقمٍ يبدو صحيحاً */
export function metricDefinition(key) {
    const found = BY_KEY.get(key);
    if (!found)
        throw new Error(`مقياسٌ غير مُعلَن: ${key}`);
    return found;
}
export function isMetricKey(value) {
    return typeof value === "string" && BY_KEY.has(value);
}
/** هل يُسأل هذا المقياسُ عند هذا المستوى — **إعلانٌ يُقرأ، لا شرطٌ يُكتَب مرّتين** */
export function metricHasLevel(key, level) {
    return metricDefinition(key).levels.includes(level);
}
/**
 * **وما لا يُقاس هنا مكتوبٌ بسببه** — فالغيابُ قرارٌ لا سهو.
 *
 * فالكروتُ والمهامُ المباشرة لها مواعيدُها وتصعيدُها وتذكيرُها اليوميّ **في
 * موديولها هو**، ولها شاشاتُها («شغلي» والبورد). وعدُّها هنا كان سيعني **تطبيقاً
 * ثانياً لـ«المتأخّر عندي»** — ويومَ يفترق التطبيقان لا أحد يعرف أيُّهما الصحيح.
 *
 * وهذا الموديولُ يقيس **خطَّ التسليم للعميل**: ما وُعِد به، ومتى سُلِّم، ومتى
 * نُشر، وكم انتظر من أُشير إليه.
 */
export const NOT_MEASURED_HERE = {
    cards: "للبطاقة موعدُها وتصعيدُها وشاشتُها في موديولها — وعدُّها هنا تطبيقٌ ثانٍ لنفس السؤال",
    tasks: "والمهمّةُ المباشرة كذلك — ولها «أعمالي» بمرشِّحاتها",
    chat: "محادثةُ العميل تنزل في الحادية عشرة — وبوّابةٌ تُلزم بإدخالها القياسَ يومها",
};
//# sourceMappingURL=registry.js.map